export type Theme = "light" | "dark" | "system";

const KEY = "wa_theme";

export function getTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "light" || v === "dark" || v === "system") return v;
  } catch {
    /* private mode */
  }
  // Light by default (2026-09-28 enterprise redesign); dark / system stay available via the toggle.
  return "light";
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme);
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* ignore */
  }
}

export function initTheme(): void {
  const t = getTheme();
  if (t !== "system") document.documentElement.setAttribute("data-theme", t);
}
